import { ref, watch, computed } from '@vue/composition-api';
import axios from '@axios';
import useAuth from '@/auth/useAuth';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useDocumentList(isTemplate) {
  const refDocumentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'label', label: i18nT(`Project`), sortable: true },
    { key: 'number', label: i18nT(`Number`), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'vendor', label: i18nT(`Client`), sortable: true },
    { key: 'amount', label: i18nT(`Amount`), sortable: true },
    { key: 'status', label: i18nT(`Status`), sortable: true },
    { key: 'created', label: i18nT(`Quote date`), sortable: true },
    { key: 'ExpirationDate', label: i18nT(`Expires on`), sortable: true },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ];
  const perPage = ref(10);
  const totalDocuments = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const invoiceType = ref({ value: -1, text: i18nT('All types') });
  const recordType = ref({ value: -1, text: i18nT('All types') });
  const vendor = ref({ value: 0, text: i18nT('All') });
  const paymentType = ref({ value: -1, text: i18nT('All types') });
  const documents = ref([]);
  const documentFilter = ref('');
  const status = ref('');

  const dataMeta = computed(() => {
    const localItemsCount = refDocumentListTable.value
      ? refDocumentListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDocuments.value,
    };
  });

  const refetchData = () => {
    refDocumentListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      invoiceType,
      recordType,
      documentFilter,
      vendor,
      paymentType,
      isSortDirDesc,
      sortBy,
      status,
    ],
    () => {
      refetchData();
    }
  );

  const fetchDocuments = (ctx, callback) => {
    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value,
    };

    if (isTemplate) {
      params.templates = 1;
    }

    if (invoiceType.value.value != -1) {
      params['filters[type]'] = invoiceType.value.value;
    }
    if (recordType.value.value != -1) {
      params['filters[record_type]'] = recordType.value.value;
    }
    if (vendor.value.value != -1) {
      params['filters[vendor]'] = vendor.value.value;
    }
    if (paymentType.value.value != -1) {
      params['filters[payment_type]'] = paymentType.value.value;
    }
    if(status.value) {
      params['filters[status]'] = status.value;
    }

    axios
      .get(`quotes`, {
        params,
      })
      .then(({ data }) => {
        documents.value = data.data.quotes;
        callback(data.data.quotes);
        totalDocuments.value = data.data.pagination.records_count;
      });
  };

  return {
    fetchDocuments,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    invoiceType,
    recordType,
    vendor,
    paymentType,
    documents,
    documentFilter,
    status,
    refetchData,
  };
}
